import {
  Grid,
  Typography,
} from "@mui/material";
import "./AboutMePage.css";
import {
  aboutMeInformation,
  MINIMUM_CLIENT_WIDTH,
} from "../../information/information";
import ContactList from "../../components/ContactList/ContactList";
function AboutMePage() {
  const isPhoneView = window.innerWidth <=MINIMUM_CLIENT_WIDTH;
  return (
    <div id="AboutMePage">
      <Grid container direction={isPhoneView?"column":"row"} spacing={1}>
        <Grid item xs={7} className="article">
          <Grid container direction={"column"} spacing={4}>
            <Grid item>
              <Typography variant="h3" className="title">
                {aboutMeInformation.title}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="body1" className="about_paragraph">
                {aboutMeInformation.paragraph}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={5}>
            <ContactList/>
        </Grid>
      </Grid>
    </div>
  );
}

export default AboutMePage;
